<template>
    <div>
        <div class="columns is-marginless is-paddingless">
            <div class="column">
                <div class="level">
                    <div class="level-left">
                        <div class="title">Billing history</div>
                    </div>
                </div>
                <div class="margin-bottom-0" v-resultsCount="total_records"></div>
            </div>
        </div>

        <div class="has-text-centered" v-if="fetching_billing">
            <p class="tag is-small is-warning is-loading"><i class="fa fa-spinner fa-spin"></i> &nbsp;Fetching billing
                history...</p>
        </div>

        <!-- list of invoices -->
        <div class="column">
            <table class="table is-fullwidth">
                <thead>
                <tr>
                    <td class="is-hidden-mobile is-size-7 has-text-weight-bold is-narrow">Reference</td>
                    <td class="is-size-7 has-text-weight-bold is-hidden-tablet is-hidden-mobile">Description</td>
                    <td class="is-size-7 has-text-weight-bold is-narrow">Description</td>
                    <td class="is-size-7 has-text-weight-bold is-hidden-tablet is-hidden-mobile">Amount</td>
                    <td class="is-size-7 has-text-weight-bold is-narrow">Amount</td>
                    <td class="is-narrow"></td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(invoice, index) in items" :key="index">
                    <td class="is-size-7 is-hidden-mobile">{{ invoice.payment_reference }}</td>
                    <td class="is-size-7">
                            <span>{{ getDescription(invoice) }}
                                <span v-if="invoice.payment_status === 'PAID'">
                                    <span class="has-text-weight-bold">Paid: {{ invoice.updated_at_date }}</span>
                                </span>
                            </span>
                    </td>
                    <td class="is-size-7">
                        <span>R{{ getPrice(invoice)}}</span>
                    </td>
                    <td>
                        <div class="buttons is-pulled-right">
                            <router-link v-if="isPendingCreditCard(invoice)"
                                         :to="`/renew-or-upgrade-subscription/card/${invoice.id}`"
                                         class="button is-button-blue is-hidden-mobile is-size-7 is-size-7-mobile">PAY
                                NOW
                            </router-link>
                            <router-link v-if="isPendingCreditCard(invoice)"
                                         :to="`/renew-or-upgrade-subscription/card/${invoice.id}`"
                                         class="button-mobile-table is-button-blue circle-border is-hidden-tablet is-fullwidth margin-right-8">
                                <i class="fas fa-credit-card"></i></router-link>

                            <a :href="`${api_url}/invoices/${invoice.id}/file`"
                               class="button is-button-blue-outline is-hidden-mobile is-size-7-mobile">DOWNLOAD INVOICE</a>
                            <a :href="`${api_url}/invoices/${invoice.id}/file`"
                               class="button-mobile-table is-button-blue is-hidden-desktop circle-border is-hidden-desktop is-hidden-tablet is-hidden-widescreen">
                                <i class="fas fa-download"></i>
                            </a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <table v-if="!fetching_billing && items.length === 0"
                   class="table is-fullwidth has-vertically-aligned-content">
                <tbody>
                <tr>
                    <td class="is-narrow">
                        <p class="is-size-7 has-text-weight-bold has-text-grey has-text-centered">There are no invoices
                            for your business.</p>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!-- paginator -->
        <paginator :dataSet="dataSet" @changed="getBillingHistory"></paginator>

    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef */
  import Paginator from '../../components/Paginator.vue'
  import misc from '../../mixins/misc.js'
  import axios from 'axios'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Billing history'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Billing History'
      })
    },
    mixins: [misc],
    components: {
      Paginator
    },
    data () {
      return {
        business_slug: localStorage.getItem('org_slug'),
        billing_history: {},
        fetching_billing: false,
        dataSet: false,
        bills_per_page: undefined,
        total_records: 0,
        items: 0,
        api_url: process.env.API_URL
      }
    },
    created () {
      this.getBillingHistory(null)
    },
    methods: {
      /**
       * Makes an api call to get list billing history for org
       * @param {number | null} page to return data from
       * @returns {void}
       */
      getBillingHistory (page) {
        this.billing_history = {}
        this.fetching_billing = true
        axios.get(this.url(page))
            .then((history) => {
              this.bills_per_page = history.data.per_page
              this.fetching_billing = false
              this.refresh(history)
              window.scrollTo(0, 0)
            })
            .catch(() => {
              this.fetching_billing = false
            })
      },
      url (page) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)

          page = query ? query[1] : 1
        }
        return `/${this.business_slug}/billing-history?page=${page}`
      },
      isPendingCreditCard (invoice) {
        return invoice.payment_status === 'PENDING' && invoice.payment_method === 'CREDIT_CARD'
      }
    }
  }
</script>

<style scoped>
    .is-danger, .is-success {
        border-radius: 0;
    }

    .table tbody tr {
        background-color: #f5f5f5 !important;
        padding: 10px !important;
    }

    .table thead tr td {
        border: none !important;
    }

    .table tbody tr td {
        vertical-align: middle;
        border: none !important;
        border-bottom: 10px solid #fff !important;
    }

    .circle-border {
        height: auto !important;
    }

    table td {
        border: 1px solid red !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/billing/History.vue